import React from 'react'

import {
    Table,
    Tag,
    Divider
} from 'antd'

import {
    _getDocs,
    _postAddDocTag,
    _postRemoveDocTag
} from '../../services'

import TagEditor from './tag-editor'

class ArticleTable extends React.Component{
    render(){

        const { docs, total, page, limit, loading } = this.state

        const columns = [{
            title: 'Title',
            dataIndex: 'title'
        },{
            title: 'Tags',
            dataIndex: 'tags',
            render: (tags) => {
                return(
                    <div>
                        {tags.map( _tag => {
                            return <Tag>{_tag}</Tag>
                        })}
                    </div>
                )
            }
        },{
            title: 'Actions',
            render:(record) => (
                <span>
                    <TagEditor
                        removeTag={(tag)=>this.handleRemoveTag({docId: record._id, tag})}
                        addTag={(tag)=>this.handleAddTag({ docId: record._id, tag})}
                        tags={record.tags}
                    />
                    <Divider type="vertical"/>
                    <a 
                    target='_blank'
                    href={`/docs/editor/${record._id}`}>
                        Article Editor
                    </a>
                </span>
            )
        }]

        return(
            <Table
                loading={loading}
                pagination={{
                    pageSize: limit,
                    total,
                    current: page,
                    onChange: (nextPage) => this.setState({ page: nextPage }, this.getDocs)
                }}
                columns={columns}
                dataSource={docs}
            />
        )
    }

    constructor(props){
        super(props)

        this.state = {
            page: 1,
            limit: 30,
            searchTerm: '',
            total: false,
            docs: [],
            loading: true
        }

        this.getDocs()
    }

    getDocs = () => {

        this.setState({loading: true})

        const { page, limit, searchTerm } = this.state

        _getDocs({page, limit, searchTerm})
        .then( res => {
            const { docs, count } = res.data

            this.setState({ docs, total: count, loading: false })
        })

    }

    handleRemoveTag = ({docId, tag}) => {

        _postRemoveDocTag({ docId, tag})
        .then( res => {

            this.setState({
                docs: this.state.docs.map( _doc => {

                    if( _doc._id == docId ){
                        _doc = res.data.doc
                    }

                    return _doc
                })
            })

        })

    }

    handleAddTag = ({docId, tag}) => {
        
        _postAddDocTag({ docId, tag })
        .then( res => {
            this.setState({
                docs: this.state.docs.map( _doc => {

                    if( _doc._id == docId ){
                        _doc = res.data.doc
                    }

                    return _doc
                })
            })
        })

    }
}

export default ArticleTable


// WEBPACK FOOTER //
// ./src/components/docs/article-table.js